<template>
  <section v-if="card.collectionCardId" class="card-profile-collection-investment">
    <h4 class="secondary-font">
      Investment
    </h4>

    <div class="stats">
      <stat-item
        label="Total Investment"
        :value="$filters.currency(totalInvestment)"
      />

      <stat-item
        v-if="card.quantity > 1"
        label="Cost Per Card"
        :value="$filters.currency(card.investment)"
      />

      <stat-item
        v-if="typeof card.priceMovement === 'number'"
        label="Daily $ Change"
        :value="`${card.priceMovement > 0 ? '+' : ''}${$filters.currency(card.priceMovement)}`"
        :success="card.priceMovement > 0"
        :error="card.priceMovement < 0"
      />

      <stat-item
        v-if="card.quantity > 1 && card.priceSold"
        label="Average Sold Price"
        :value="$filters.currency(card.priceSold)"
      />

      <stat-item
        v-if="card.sold && typeof card.priceSold === 'number' && typeof card.quantitySold === 'number'"
        :label="`${card.quantity > 1 ? 'Total ' : ''}Sold Price`"
        :value="$filters.currency(card.priceSold * card.quantitySold)"
      />

      <stat-item
        v-if="typeof card.profit === 'number'"
        :label="profitLabel"
        :value="`${card.profit > 0 ? '+' : ''}${$filters.currency(card.profit)}`"
        :success="card.profit > 0"
        :error="card.profit < 0"
      />

      <stat-item
        v-if="typeof roi === 'number'"
        :label="roiLabel"
        :value="`${roi > 0 ? '+' : ''}${$filters.percentage(roi)}`"
        :success="roi > 0"
        :error="roi < 0"
      />

      <stat-item
        v-if="card.ownsPercentage && typeof card.ownershipPercentage === 'number'"
        :label="`${card.quantity > 1 ? 'Total ' : ''}Ownership %`"
        :value="$filters.percentage(card.ownershipPercentage / 100)"
      />
    </div>
  </section>
</template>

<script>
import StatItem from '@cardladder/shared/components/StatItem';

import { getCollectionCardInvestments } from '@cardladder/shared/utils/collection.util';

export default {
  components: {
    StatItem,
  },

  props: {
    card: Object,
  },

  computed: {
    totalInvestment() {
      return getCollectionCardInvestments(this.card).totalInvestment;
    },

    roi() {
      if (!this.card.quantity || typeof this.card.profit !== 'number') {
        return null;
      }

      if (!this.card.profit || !this.totalInvestment) {
        return 0;
      }

      return this.card.profit / this.totalInvestment;
    },

    profitLabel() {
      return this.card.sold && this.card.quantity === this.card.quantitySold ? 'Profit' : 'Potential Profit';
    },

    roiLabel() {
      return this.card.sold && this.card.quantity === this.card.quantitySold ? 'ROI' : 'Potential ROI';
    },
  },
};
</script>

<style lang="scss" scoped>
.card-profile-collection-investment {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}

.stats {
  display: grid;
  grid-gap: $gp;
  grid-template-columns: repeat(4, 1fr);

  &.page {
    @media($medium-up) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media($small-down) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
